/* import __COLOCATED_TEMPLATE__ from './content-slot.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {}

interface Signature {
  Element: HTMLElement;
  Args: Args;
  Blocks: any;
}

const ContentSlot = templateOnlyComponent<Signature>();
export default ContentSlot;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Layout::Module::ContentSlot': typeof ContentSlot;
    'layout/module/content-slot': typeof ContentSlot;
  }
}
